export default {
  // getauthcode: '/sso/sms',
  // checkcode: '/sso/verifyCode',
  getauthcode: '/sso/getAuthCode',
  checkcode: '/sso/verifyAuthCodeAndRecord',
};



// WEBPACK FOOTER //
// ./src/api/phonevalidate.js